export default __webpack_public_path__ + "static/media/marketplace_openapi.0be64db9.yaml";